/* Frostik cart drawer (same approach as the Magnetik drawer, without the gift logic).
 * - Opens on add to cart and on the header cart icon.
 * - After any change, the drawer HTML is re-fetched through Shopify's Section
 *   Rendering API, so prices, automatic discounts and totals come from Liquid.
 * - Bundle prices are real Shopify automatic discounts (Buy 2 / Buy 3), so no
 *   discount codes are handled here.
 */
window.FrostikDrawer = (function () {
  'use strict';
  var SEL = '#cart-drawer';
  var sectionId = null, lastFocus = null, busy = false;

  function root() { return document.querySelector(SEL); }
  function base() { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, ''); }

  function resolveSectionId() {
    if (sectionId) return sectionId;
    var el = root();
    while (el && el !== document.body) {
      if (el.id && el.id.indexOf('shopify-section-') === 0) { sectionId = el.id.replace('shopify-section-', ''); return sectionId; }
      el = el.parentElement;
    }
    return null;
  }

  function open() {
    var r = root(); if (!r) return;
    lastFocus = document.activeElement;
    r.classList.add('open'); r.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fkc-locked');
    var x = r.querySelector('.fkc-x'); if (x) x.focus();
  }
  function close() {
    var r = root(); if (!r) return;
    r.classList.remove('open'); r.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fkc-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function syncCount() {
    return fetch(base() + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.setAttribute('data-empty', c.item_count === 0 ? 'true' : 'false');
        });
        return c;
      }).catch(function () {});
  }

  function refresh() {
    var id = resolveSectionId();
    if (!id) return Promise.resolve();
    var q = new URLSearchParams(window.location.search), out = new URLSearchParams();
    ['preview_theme_id', 'view', '_ab', '_fd', '_sc'].forEach(function (k) { if (q.has(k)) out.set(k, q.get(k)); });
    out.set('section_id', id);
    return fetch(window.location.pathname + '?' + out.toString(), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(SEL);
        var cur = root();
        if (!fresh || !cur) return;
        var wasOpen = cur.classList.contains('open');
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) { cur.classList.add('open'); cur.setAttribute('aria-hidden', 'false'); }
        return syncCount();
      }).catch(function () {});
  }

  function change(key, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    var r = root(); if (r) r.classList.add('fkc-drawer-busy');
    return fetch(base() + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { if (!res.ok) throw new Error('change failed'); return res.json(); })
      .then(refresh).catch(function () {})
      .then(function () { busy = false; var rr = root(); if (rr) rr.classList.remove('fkc-drawer-busy'); });
  }

  /* Add to cart from a Frostik product form, then open the drawer.
     If anything fails, fall back to the normal form post (goes to /cart). */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('fk-form') || !root()) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(base() + '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () { return refresh(); })
      .then(open)
      .catch(function () { f.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-drawer-close]')) { if (!t.closest('a[href]')) e.preventDefault(); close(); return; }
    var q = t.closest('.qty-up, .qty-down, .cart-remove');
    if (q && q.closest(SEL)) { e.preventDefault(); change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-q'), 10)); return; }
    var cartLink = t.closest('.fkc-cart-link');
    if (cartLink && root()) { e.preventDefault(); refresh().then(open); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root() && root().classList.contains('open')) close(); });

  syncCount();
  return { open: open, close: close, refresh: refresh, syncCount: syncCount };
})();
